import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// @ts-ignore
import { makeSelectUserValue } from 'services/people/selectors';

import { AppState } from 'services/types';

interface OwnProps {
    userEmail: string;
}

interface StateProps {
    fullName?: string;
}

export interface Props extends OwnProps, StateProps {}

export class UserFullName extends React.PureComponent<Props> {
    render(): string | null {
        const { fullName } = this.props;
        if (!fullName) {
            return null;
        }
        return fullName;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    StateProps
>({
    fullName: makeSelectUserValue('fullName')
});

export default connect(mapStateToProps)(UserFullName);
